// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import uniqueId from "@insite/mobius/utilities/uniqueId";
/* Store Custom Code - End */

interface OwnProps {
    heading?: string | React.ReactNode; // Store Custom Code
    text: string | number | React.ReactNode; // Store Custom Code
    extendedStyles?: SmallHeadingAndTextStyles;
    // Starter Custom Code
    overridedStyles?: SmallHeadingAndTextStyles;
    // Store Custom Code
    useAriaLabel?: boolean;
}

export interface SmallHeadingAndTextStyles {
    wrapper?: InjectableCss;
    heading?: TypographyProps;
    text?: TypographyProps;
    // Starter Removed - extendedStyles
}

export const smallHeadingAndTextStyles: SmallHeadingAndTextStyles = {
    heading: {
        /* Store Custom Code - Start */
        forwardAs: "p",
        /* Store Custom Code - End */
        variant: "legend",
    },
    text: {
        /* Store Custom Code - Start */
        forwardAs: "p",
        /* Store Custom Code - End */
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
};

const SmallHeadingAndText: React.FunctionComponent<OwnProps> = ({
    heading,
    text,
    extendedStyles,
    overridedStyles, // Starter Custom Code
    /* Store Custom Code - Start */
    useAriaLabel,
    /* Store Custom Code - End */
    ...otherProps
}) => {
    const styles = useExpandProps(smallHeadingAndTextStyles, extendedStyles, overridedStyles); // Starter Custom Code
    /* Store Custom Code - Start */
    const uid = React.useMemo(() => uniqueId(), []);
    /* Store Custom Code - End */

    return (
        <StyledWrapper {...styles.wrapper} {...otherProps}>
            {Boolean(heading) /* Store Custom Code */ && (
                <Typography
                    // Store Removed - as
                    {...styles.heading}
                    data-test-selector="heading"
                    // Store Custom Code
                    id={useAriaLabel ? uid : undefined}
                >
                    {heading}
                </Typography>
            )}
            <Typography
                // Store Removed - as
                {...styles.text}
                data-test-selector={`text_${heading}`}
                // Store Custom Code
                aria-labelledby={useAriaLabel ? uid : undefined}
            >
                {text}
            </Typography>
        </StyledWrapper>
    );
};

export default SmallHeadingAndText;
